import { TPaginationConfig } from '@/common/components/redesigned/Table/types/tableTypes';

export const PAGINATION_CONFIG: TPaginationConfig = {
  size: 150,
};
